<template>
  <div class="forgotten-password">
    <div
      class="forgotten-password__form-response"
      v-if="forgotPasswordSuccessMsg || forgotPasswordErrorMsg"
    >
      <p
        v-if="forgotPasswordSuccessMsg"
        class="body-copy body-copy--align-center body-copy--fw-500"
      >
        A reset link has been sent to you. Click on it to reset your password
      </p>
      <p
        v-if="forgotPasswordErrorMsg"
        class="body-copy body-copy--align-center body-copy--fw-500 body-copy--color-error"
      >
        {{ forgotPasswordErrorMessage }}
      </p>
    </div>

    <FormulateForm
      @submit="submitForm"
      class="formulate-form forgotten-password__formulate-form"
    >
      <FormulateInput
        type="email"
        name="email"
        v-model="userEmail"
        label="Email"
        validation="required|email"
        :wrapper-class="['formulate-input-wrapper--container']"
        :label-class="['formulate-input-label--contained']"
        :element-class="['formulate-input-element--contained']"
      />

      <div class="formulate-form__form-footer">
        <FormulateInput type="submit" name="Recover" :input-class="'btn'" />

        <p class="formulate-form__footer-copy">
          Don’t have an account?
          <router-link to="/join" class="formulate-form__link"
            >Sign in now</router-link
          >
        </p>
      </div>
    </FormulateForm>
  </div>
</template>

<script>
export default {
  name: "ForgottenPasswordForm",
  data() {
    return {
      userEmail: null,
      forgotPasswordSuccessMsg: false,
      forgotPasswordErrorMsg: false,
      forgotPasswordErrorMessage: "",
    };
  },
  methods: {
    async submitForm() {
      let forgotpasword = await this.$store.dispatch(
        "UserManagement/forgetPassword",
        { email: this.userEmail }
      );

      if (forgotpasword) {
        this.forgotPasswordSuccessMsg = true;
      }

      if (!forgotpasword) {
        this.forgotPasswordErrorMsg = true;
        this.forgotPasswordErrorMessage = JSON.parse(
          sessionStorage.getItem("_khonsu_user_forgetPassword_failed_msg")
        ).message;
      }
    },
  },
};
</script>
